export default __webpack_public_path__ + "static/media/red_pawn.64d55466.png";